import { Routes } from '@angular/router';
import { userGuard } from '@core/guards';
import { centralShippingGuard } from '@core/guards/central-shipping.guard';
import { PageTitleEnum } from '@shared/enums';

export const centralShippingRoutes: Routes = [
    {
        path: '',
        canActivate: [userGuard],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./central-shipping-overview/central-shipping-overview.component').then(
                        mod => mod.CentralShippingOverviewComponent
                    ),
                canActivate: [centralShippingGuard],
                title: PageTitleEnum.CENTRAL_SHIPPING,
            },
        ],
    },
];
